import {required} from "vuelidate/lib/validators";
import {ModelObject} from "@/pages/Common/modelObject";

export const CONTRACT_TYPE = {
    1: 'Пункт временного содержания',
    2: 'Приют',
    3: 'ОМСУ'
}


export class Contract extends ModelObject {
    constructor(initObjectParams) {
        super(initObjectParams)
        this.id = null;
        this.number = null;
        this.price = null;
        this.animalsLimit = null;
        this.contractType = 1;
        this.contractTypeText = CONTRACT_TYPE[this.contractType];
        this.validFrom = null;
        this.validUntil = null;


        this.customer = null;
        this.contractor = null;
        this.customerObject = {};
        this.contractorObject = {};

        this.applyInitObjectParams(initObjectParams);
    }

    static get modelName() {
        return 'Contract'
    }

    static get validations() {
        return {
            number: { required },
            price: {  },
            animalsLimit: {  },
            contractType: {  },
            customer: { required },
            contractor: { required },
            validFrom: { required },
            validUntil: {  }
        }
    }

    static get validationFieldLabels() {
        return {
            number: 'Номер',
            price: 'Стоимость',
            animalsLimit: 'Количество животных',
            contractType: 'Тип контракта',
            customer: 'Заказчик',
            contractor: 'Исполнитель',
            validFrom: 'Дата начала',
            validUntil: 'Дата окончания'
        }
    }

    static get mapping() {
        return {
            animalsLimit: 'animals_limit',
            contractType: 'contract_type',
            validFrom: 'valid_from',
            validUntil: 'valid_until'
        }
    }

    static get label() {
        return 'Контракт'
    }

    label() {
        return 'Контракт'
    }

    static get newLabel() {
        return 'Новый контракт'
    }

    objectLabel() {
        return `Контракт №${this.number}`
    }

     _date(value) {
        if (value) {
            const parts = value.split(' ')
            if (Array.isArray(parts) && parts.length > 0) {
                return parts[0]
            }
        }
        return null
    }

    _time(value) {
        if (value) {
            const parts = value.split(' ')
            if (Array.isArray(parts) && parts.length > 0) {
                return parts[1]
            }
        }
        return null
    }

    get validFromDate() {
        return this._date(this.validFrom)
    }

    get validFromTime() {
        return this._time(this.validFrom)
    }
    get validUntilDate() {
        return this._date(this.validUntil)
    }

    get validUntilTime() {
        return this._time(this.validUntil)
    }

}